import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { QuotationStatus } from 'components/ordering/quotation/api/dtos/quotation-status.js'

@customElement('csc-quotation-status')
export class CSCQuotationStatus extends LitElement {
  @property({ type: String, reflect: true, attribute: 'status' })
  status!: QuotationStatus

  get translation(): string {
    switch (this.status) {
      case 'open':
        return t('open', { ns: 'csc-quotation-status', default: 'Open' }).toString()
      case 'draft':
        return t('draft', { ns: 'csc-quotation-status', default: 'Draft' }).toString()
      case 'requested':
        return t('requested', { ns: 'csc-quotation-status', default: 'Requested' }).toString()
      case 'review':
        return t('review', { ns: 'csc-quotation-status', default: 'In review' }).toString()
      case 'answered':
        return t('answered', { ns: 'csc-quotation-status', default: 'Answered' }).toString()
      case 'accepted':
        return t('accepted', { ns: 'csc-quotation-status', default: 'Accepted' }).toString()
      case 'confirmed':
        return t('confirmed', { ns: 'csc-quotation-status', default: 'Confirmed' }).toString()
      case 'declined':
        return t('declined', { ns: 'csc-quotation-status', default: 'Declined' }).toString()
      case 'declined_by_merchant':
        return t('declined_by_merchant', { ns: 'csc-quotation-status', default: 'Declined by merchant' }).toString()
      case 'overdue':
        return t('overdue', { ns: 'csc-quotation-status', default: 'Overdue' }).toString()
      default:
        return this.status
    }
  }

  get badgeVariant(): 'default' | 'info' | 'success' | 'error' {
    switch (this.status) {
      case 'open':
        return 'info'
      case 'draft':
        return 'default'
      case 'requested':
        return 'info'
      case 'review':
        return 'info'
      case 'answered':
        return 'info'
      case 'accepted':
        return 'success'
      case 'confirmed':
        return 'success'
      case 'declined':
        return 'error'
      case 'declined_by_merchant':
        return 'error'
      case 'overdue':
        return 'error'
      default:
        return 'default'
    }
  }

  override render() {
    return html`
      <cse-badge class="status" variant="${this.badgeVariant}">${this.translation}</cse-badge>
    `
  }
}
